import "../styles/reports.css";
export default function Reports() {
  const reportsData = {
    revenue: {
      today: 245.75,
      thisWeek: 1200.5,
      thisMonth: 4500.0,
    },
    orders: {
      today: 28,
      thisWeek: 150,
      thisMonth: 560,
    },
    lowStockItems: 4,
    topProducts: [
      { name: "Classic Burger", sold: 75 },
      { name: "Chicken Sandwich", sold: 50 },
      { name: "Fries", sold: 100 },
      { name: "Coke", sold: 120 },
    ],
  };

  return (
    <>
      <h1>Reports</h1>
      <div className="reports-grid">
        <div className="report-card">
          <p className="label">Revenue Today</p>
          <h2>${reportsData.revenue.today}</h2>
        </div>
        <div className="report-card">
          <p className="label">Revenue This Week</p>
          <h2>${reportsData.revenue.thisWeek}</h2>
        </div>
        <div className="report-card">
          <p className="label">Revenue This Month</p>
          <h2>${reportsData.revenue.thisMonth}</h2>
        </div>
        <div className="report-card">
          <p className="label">Orders Today</p>
          <h2>{reportsData.orders.today}</h2>
        </div>
        <div className="report-card">
          <p className="label">Orders This Week</p>
          <h2>{reportsData.orders.thisWeek}</h2>
        </div>
        <div className="report-card">
          <p className="label">Orders This Month</p>
          <h2>{reportsData.orders.thisMonth}</h2>
        </div>
        <div className="report-card warning">
          <p className="label">Low Stock Items</p>
          <h2>{reportsData.lowStockItems}</h2>
        </div>
      </div>
      <section className="page-title-section">
        <h2 style={{ marginTop: "24px" }}>Top Selling Products</h2>
        <button className="btn">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-filetype-xlsx"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M14 4.5V11h-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zM7.86 14.841a1.13 1.13 0 0 0 .401.823q.195.162.479.252.284.091.665.091.507 0 .858-.158.355-.158.54-.44a1.17 1.17 0 0 0 .187-.656q0-.336-.135-.56a1 1 0 0 0-.375-.357 2 2 0 0 0-.565-.21l-.621-.144a1 1 0 0 1-.405-.176.37.37 0 0 1-.143-.299q0-.234.184-.384.188-.152.513-.152.214 0 .37.068a.6.6 0 0 1 .245.181.56.56 0 0 1 .12.258h.75a1.1 1.1 0 0 0-.199-.566 1.2 1.2 0 0 0-.5-.41 1.8 1.8 0 0 0-.78-.152q-.44 0-.777.15-.336.149-.527.421-.19.273-.19.639 0 .302.123.524t.351.367q.229.143.54.213l.618.144q.31.073.462.193a.39.39 0 0 1 .153.326.5.5 0 0 1-.085.29.56.56 0 0 1-.255.193q-.168.07-.413.07-.176 0-.32-.04a.8.8 0 0 1-.249-.115.58.58 0 0 1-.255-.384zm-3.726-2.909h.893l-1.274 2.007 1.254 1.992h-.908l-.85-1.415h-.035l-.853 1.415H1.5l1.24-2.016-1.228-1.983h.931l.832 1.438h.036zm1.923 3.325h1.697v.674H5.266v-3.999h.791zm7.636-3.325h.893l-1.274 2.007 1.254 1.992h-.908l-.85-1.415h-.035l-.853 1.415h-.861l1.24-2.016-1.228-1.983h.931l.832 1.438h.036z"
            />
          </svg>
          Export Data
        </button>
      </section>

      <table className="top-products-table">
        <thead>
          <tr>
            <th>Product</th>
            <th>Sold</th>
          </tr>
        </thead>
        <tbody>
          {reportsData.topProducts.map((p, i) => (
            <tr key={i}>
              <td>{p.name}</td>
              <td>{p.sold}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
}
